import { css } from 'aphrodite';
import * as React from 'react';
import { AdminPermission } from '../../../viewmodels/AdminViewModels';
import { ConditionalAccess } from '../../components/ConditionalAccess';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { MetaConnectionModal } from '../../containers/adsMeta/MetaConnectionModal';
import { MetaHealthCard } from '../../containers/adsMeta/MetaHealthCard';
import { MetaVisibleAssetsTable } from '../../containers/adsMeta/MetaVisibleAssetsTable';
import { styleSheet } from './styles';

export const AdminAdsMetaPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<ConditionalAccess
				permission={AdminPermission.OnlyForDevelopers}
				elseChildren={
					<div className={css(styleSheet.notAuthorized)}>
						The Meta admin tools are restricted to developers while the operator role is being finalized.
					</div>
				}
			>
				<AdsMetaContent />
			</ConditionalAccess>
		</AdminDashboardPageLayout>
	);
};

const AdsMetaContent: React.FC = () => {
	const [openConnection, setOpenConnection] = React.useState<{ id: string; name: string | null } | null>(null);

	return (
		<div className={css(styleSheet.page)}>
			<header className={css(styleSheet.pageHeader)}>
				<h1 className={css(styleSheet.pageTitle)}>Meta Ads</h1>
				<p className={css(styleSheet.pageSubtitle)}>
					Manage Levitate's Meta System User token and the ad accounts the ads team operates on customers' behalf.
				</p>
			</header>
			<MetaHealthCard />
			<MetaVisibleAssetsTable onEditConnection={(id, name) => setOpenConnection({ id, name })} />
			{openConnection ? (
				<MetaConnectionModal
					levitateAccountId={openConnection.id}
					levitateAccountName={openConnection.name}
					onClose={() => setOpenConnection(null)}
				/>
			) : null}
		</div>
	);
};
